"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartLineUp = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ChartLineUp = function () { return (react_1.default.createElement("path", { fill: "currentColor", d: "M9.78 9.327a.576.576 0 01.84 0l3.18 3.18 8.33-8.33a.6.6 0 01.852 0l.84.84a.6.6 0 010 .853l-9.601 9.602a.576.576 0 01-.84 0l-3.181-3.18-8.33 8.329a.6.6 0 01-.852 0l-.84-.84a.6.6 0 010-.852L9.78 9.327z" })); };
exports.ChartLineUp = ChartLineUp;
//# sourceMappingURL=chart-line-up.js.map